import { Box, SvgIconProps } from '@mui/material';


import { makeStyles } from 'tss-react/mui';


export type FormSectionProps = {
  icon: React.ComponentType<SvgIconProps>;
  includeLabel?: boolean;
  iconHeight?: string;
};


export const useStyles = makeStyles<Partial<FormSectionProps>>()((theme, props) => ({
  wrapper: {
    display: 'flex',
    flexDirection: 'row',
    width: '100%',
  },
  iconWrapper: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    paddingRight: '8px',
    marginTop: props.includeLabel ? theme.spacing(3) : 0,
    height: props.iconHeight ? props.iconHeight : '50px',
    color: theme.palette.text.secondary,
  },
  content: {
    display: 'flex',
    flex: '1',
    width: '100%',
  },
}));


export const FormSection: React.FC<FormSectionProps> = ({
  icon: Icon,
  includeLabel,
  iconHeight,
  children,
}) => {
  const { classes } = useStyles({ includeLabel, iconHeight });

  return (
    <Box className={classes.wrapper}>
      <Box className={classes.iconWrapper}>
        <Icon fontSize="small" />
      </Box>
      <Box className={classes.content}>
        {children}
      </Box>
    </Box>
  );
};


FormSection.defaultProps = {
  includeLabel: false,
};
